define('bindingHandlers/advanceFocusForGUID',[
    'lib/knockout',
    'util/keyCode',
    'jquery'
], function (ko, keyCode, $) {
    'use strict';

    // Advances focus to the next field when the user enters a dash or input reaches maxlength
    ko.bindingHandlers.advanceFocusForGUID = {
        init: function (element, valueAccessor) {
            var $element = $(element),
                nextElementId = valueAccessor(),
                maxLength = parseInt($element.attr('maxlength'), 10);

            $element.on('keyup.advance-focus', function (event) {
                var currentLength = $element.val().length;
                var isShiftTab = event.keyCode === keyCode.SHIFT || event.keyCode === keyCode.TAB;
                if ((event.which === keyCode.DASH || currentLength === maxLength) && !isShiftTab) {
                    event.preventDefault();
                    $(nextElementId).focus();
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.off('.advance-focus');
            });
        }
    };

    return ko.bindingHandlers.advanceFocusForGUID;
});
